import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';

export default function PortalDocuments({
  busy,
  error,
}: {
  busy: (x: string) => void;
  error: (x: string) => void;
}) {
  const [items, setItems] = useState<any[]>([]);
  const [summary, setSummary] = useState({ current: 0, expired: 0, expiringSoon: 0 });
  useEffect(() => {
    void Promise.all([
      apiClient.get('/employee-portal/documents'),
      apiClient.get('/employee-portal/documents/summary'),
    ])
      .then(([d, s]) => {
        setItems(d.data);
        setSummary(s.data);
      })
      .catch(() => error('No se pudo cargar la documentación del legajo.'));
  }, []);
  const open = async (d: any, download = false) => {
    busy(download ? 'Preparando descarga…' : 'Abriendo documento…');
    try {
      const r = await apiClient.get(`/employee-portal/documents/${d.id}/file`, {
        params: { download: download ? '1' : '0' },
        responseType: 'blob',
      });
      const url = URL.createObjectURL(r.data);
      if (download) {
        const a = document.createElement('a');
        a.href = url;
        a.download = d.displayName;
        a.click();
        URL.revokeObjectURL(url);
      } else {
        window.open(url, '_blank', 'noopener,noreferrer');
        setTimeout(() => URL.revokeObjectURL(url), 60000);
      }
    } catch {
      error('No se pudo acceder al documento.');
    } finally {
      busy('');
    }
  };
  return (
    <section>
      <div className="portal-document-stats">
        <span>
          <strong>{summary.current}</strong>Vigentes
        </span>
        <span>
          <strong>{summary.expiringSoon}</strong>Próximos a vencer
        </span>
        <span>
          <strong>{summary.expired}</strong>Vencidos
        </span>
      </div>
      {items.length === 0 ? (
        <div className="portal-empty">
          <strong>No tenés documentos habilitados</strong>
          <span>Cuando la empresa publique uno, aparecerá acá.</span>
        </div>
      ) : (
        <div className="portal-documents">
          {items.map((d) => (
            <article key={d.id}>
              <div className="receipt-icon">{d.mimeType === 'application/pdf' ? 'PDF' : 'IMG'}</div>
              <div className="receipt-info">
                <span>{d.category.name}</span>
                <strong>{d.displayName}</strong>
                <small>
                  {d.expirationDate
                    ? `Vence ${String(d.expirationDate).slice(0, 10)}`
                    : 'Sin vencimiento'}{' '}
                  · {(Number(d.size) / 1024).toFixed(0)} KB
                </small>
              </div>
              <div className={`portal-status ${d.validity === 'CURRENT' ? 'is-signed' : ''}`}>
                {d.validity === 'EXPIRED'
                  ? 'Vencido'
                  : d.validity === 'EXPIRING_SOON'
                    ? 'Próximo a vencer'
                    : 'Vigente'}
              </div>
              <div className="receipt-actions">
                <button className="portal-secondary" onClick={() => void open(d)}>
                  Ver
                </button>
                <button className="portal-primary" onClick={() => void open(d, true)}>
                  Descargar
                </button>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
}
